import { LOGIN_USER_SUCCESS, LOGOUT_USER } from "./types";
// import { obtainToken, logout } from "../../components/api/authenticationApi";
import { obtainToken, logout } from "../../components/api/authenticationApi2";

export function loginUserSuccess(token) {
    return { type: LOGIN_USER_SUCCESS, token };
}

export function loginUser(username, password) {
    return async function (dispatch) {
        const tokens = await obtainToken(username, password);
        // if (tokens.ok) {
        //     const body = await tokens.json();
        const accessToken = tokens["access_token"];
        //     console.log(body);
        //     // dispatch(loginUserSuccess(response.data.access));
        dispatch(loginUserSuccess(accessToken));
        // }
        return tokens;
    };
}

export function logoutUserSuccess() {
    return { type: LOGOUT_USER };
}

export function logoutUser() {
    return async function (dispatch) {
        await logout();
        dispatch(logoutUserSuccess());
    };
}
